/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
/* eslint-disable */



import { isOfficialSite } from "./components/isofficialsite.js"
import "../css/theme.scss";
import "expose-loader?Tether!tether";
import "bootstrap/dist/js/bootstrap.min.js";
//import "flexibility";

//import "jquery-touchswipe";
import "./selectors.js";
import "./responsive.js";
//import "./checkout";


// import "./customer"; FOR RETURN ORDER
//import "./listing"; FOR OLD FILTER PRODUCTS

import "./components/ps_mainmenu.js";
//import "lazysizes/lazysizes.min.js";

import prestashop from "prestashop";
import EventEmitter from "events";
//import DropDown from "./components/drop-down";
import Form from "./components/form.js";
// import ProductMinitature from "./components/product-miniature";

//import TopMenu from "./components/top-menu";
//import "./lib/bootstrap-filestyle.min";
//import "./lib/jquery.scrollbox.min";
import "./components/block-cart.js";
import "./components/cookiechoice.js";
import "./components/oryxSearch.js";
//import "./components/address";
import "./modules/ps_shoppingcart/ps_shoppingcart.js";
import "./modules/ps_searchbar/ps_searchbar.js";
import { gtagEvent } from "./components/googleDataLayer.js";
import $ from "jquery";



if (typeof gameIsOnline !== "undefined" && gameIsOnline === true) {
  import(
    /* webpackChunkName: "initGameOnSiteComponents" */
    "./modules/game/components/onSite.js"
  ).then((initGameOnSiteComponentsImport) => {
    initGameOnSiteComponentsImport.initGameOnSiteComponents();
  });
}




/* eslint-enable */

//import QuantityInput from "./components/quantity.js";

// "inherit" EventEmitter
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {

  gtagEvent("gender");

  ap5_setPackContentData();
  $(document).ajaxSuccess(function () {
    ap5_setPackContentData();
  });
  $(document).on('ap5-After-AddPackToCart', function () {
    ap5_setPackContentData();
  });


  if ($('#product-information').length) {
    gtagEvent("view_item");
  }

  if ($('#order-confirmation').length) {
    gtagEvent("purchase");
  }
  console.log('official ?', isOfficialSite());

  $('.show_me_ratio').on('click', function () {
    alert(window.devicePixelRatio);
  });
  //const dropDownEl = $(".js-dropdown");
  const form = new Form();
  //const topMenuEl = $('.js-top-menu ul[data-depth="0"]');

  //const dropDown = new DropDown(dropDownEl);

  //const topMenu = new TopMenu(topMenuEl);
  //const productMinitature = new ProductMinitature();
  //const productSelect = new ProductSelect();
  //dropDown.init();
  form.init();
  //topMenu.init();
  //productMinitature.init();
  //productSelect.init();

  /*$('.carousel[data-touch="true"]').swipe({
    swipe(event, direction) {
      if (direction === "left") {
        $(this).carousel("next");
      }
      if (direction === "right") {
        $(this).carousel("prev");
      }
    },
    allowPageScroll: "vertical",
  });*/
});
